import styled from "@emotion/styled";
import { baseFormLabelClasses } from "./../../base-form-label/BaseFormLabel";
import { FormLabel, FormLabelProps } from "../form-label/FormLabel";

const StyledFormLabelWithDescription = styled("div")(({ theme }) => ({
    display: "flex",
    columnGap: theme.spacing(1),
    alignItems: "center",
}));

const StyledFormLabel = styled(FormLabel)({
    [`& .${baseFormLabelClasses.label}`]: {
        paddingBottom: 0,
    },
    [`&.${baseFormLabelClasses.root}`]: {
        marginBottom: 0,
    },
});

export function FormLabelWithDescription({ className, ...rest }: FormLabelProps) {
    return (
        <StyledFormLabelWithDescription className={className}>
            <StyledFormLabel {...rest} />
        </StyledFormLabelWithDescription>
    );
}

export default FormLabelWithDescription;
